module.exports = __webpack_public_path__ + "static/media/shield-check.f8ea9b73.svg";